import graphqlClient from "./graphqlClient";
import {CREATE_USER_CLIP, GET_AVAILABLE_WATERMARKS, OUTPUT_TYPES} from "./graphql/clippy-mutations";

const CROP_RATIOS = {
  "4:5": "CROP_FOUR_FIVE",
  "1:1": "CROP_ONE_ONE",
  "9:16": "CROP_NINE_SIXTEEN"
};

const CROSS_FADE = "CROSS_FADE";
const ADD_WATERMARK = "ADD_MLB_WATERMARK";
const DEFAULT_UNSET_WATERMARK = "None";
const DEFAULT_MLB_WATERMARK = "mlb.png";
const ADD_CUSTOM_WATERMARK = "WATERMARK";
const GENERATE_SINGLE_THUMBNAIL = "GENERATE_SINGLE_THUMBNAIL";

export default class ClippyApi {
  createUserClip(
    clips,
    applyCrossfade = false,
    generateThumbnail = true,
    cropRatio = "None",
    watermark = DEFAULT_UNSET_WATERMARK
  ) {
    let options = [];
    let preferences = [];

    if (applyCrossfade) {
      options.push(CROSS_FADE);
    }

    if (watermark && watermark !== DEFAULT_UNSET_WATERMARK) {
      preferences.push({
        preference: ADD_CUSTOM_WATERMARK,
        watermarkFilename: watermark
      });
    }

    if (generateThumbnail) {
      options.push(GENERATE_SINGLE_THUMBNAIL);
    }

    if (cropRatio && cropRatio !== "None") {
      options.push(CROP_RATIOS[cropRatio]);
    }

    const videoClips = [];
    clips.forEach(clip => {
      videoClips.push({
        playId: clip.playId,
        gamePk: clip.gamePk,
        feedType: clip.feedType,
        url: clip.url,
        assetId: clip.assetId,
        startOffset: clip.startOffset,
        endOffset: clip.relativeEndOffset ? clip.relativeEndOffset : 0,
        type: clip.type
      });
    });

    const userClipRequestInput = {
      videoClips,
      options,
      preferences,
      outputTypes: ["HLS", "MP4"]
    };

    return graphqlClient
      .mutate({
        mutation: CREATE_USER_CLIP,
        variables: {
          userClipRequestInput
        }
      })
      .then(r => r.data)
      .then(r => {
        return r.createUserClip;
      });
  }

  getOutputTypes(clipId) {
    return graphqlClient
      .mutate({
        mutation: OUTPUT_TYPES,
        variables: {clipId, clipOutputTypeRequest: ["HLS", "MP4"]}
      })
      .then(r => r.data)
      .then(r => {
        return r.outputTypes;
      });
  }

  getAvailableWatermarks() {
    return graphqlClient
      .query({
        query: GET_AVAILABLE_WATERMARKS
      })
      .then(r => r.data)
      .then(r => {
        return r.availableWatermarks;
      });
  }
}

export {CROSS_FADE, ADD_WATERMARK, CROP_RATIOS, DEFAULT_MLB_WATERMARK, DEFAULT_UNSET_WATERMARK};



// WEBPACK FOOTER //
// ./src/httpClients/ClippyApi.js